
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TheCrm',
  computed: {
    ...mapState('session', ['sessionParams'])
  },
  created() {
    const query = this.$route.query;
    this.setSessionParams(query);
  },
  methods: {
    ...mapActions('session', ['setSessionParams'])
  }
};
